import Guid from "_shared/guids/guid";
import MarketplaceSearchRequestSchema, {
  MarketplaceSearchRequestJSON,
} from "marketplace/_schema/marketplace-search-request-schema";
import SavedSearchSchema, { SavedSearchJSON } from "marketplace/saved-searches/_schema/saved-search-schema";

/** A marketplace search its owner has named and kept, and may be told about new matches for. */
export default class SavedSearch {
  public static fromJSON(json: unknown): SavedSearch {
    return new SavedSearch(SavedSearchSchema.validateJSON(json));
  }

  public readonly id: Guid;
  public readonly name: string;
  public readonly alertsEnabled: boolean;
  public readonly createdDate: Date;
  public readonly criteria: MarketplaceSearchRequestJSON;

  /** The marketplace page with the search's filters and sort, as it was saved. */
  public get marketplaceUrl(): string {
    const params = MarketplaceSearchRequestSchema.toPageSearchParams(this.criteria);
    const query = params.toString();
    return query ? `/marketplace?${query}` : "/marketplace";
  }

  private constructor(json: SavedSearchJSON) {
    this.id = new Guid(json.id);
    this.name = json.name;
    this.alertsEnabled = json.alertsEnabled;
    this.createdDate = new Date(json.createdDate);
    this.criteria = json.criteria;
  }

  public isEqualTo(other: SavedSearch | null | undefined): boolean {
    return (
      this.id.isEqualTo(other?.id) &&
      this.name === other?.name &&
      this.alertsEnabled === other.alertsEnabled
    );
  }

  public toJSON(): SavedSearchJSON {
    return {
      id: this.id.value,
      name: this.name,
      alertsEnabled: this.alertsEnabled,
      createdDate: this.createdDate.toISOString(),
      criteria: this.criteria,
    };
  }

  public toString(): string {
    return this.name;
  }
}
